<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup>
const RuntimeConfig = useRuntimeConfig()

const refreshToken = localStorage.getItem(
  `taline-mini-game-${RuntimeConfig.public.GAME_VALUE}-refresh-token`,
)
const searchParams = new URLSearchParams(window.location.search)

const friendToken = searchParams.get('ft')
const user = useUserStore()

if (friendToken) {
  user.friendToken = friendToken
}

if (refreshToken) {
  await user.profile()

  if (user?.user?.userGame) {
    user.shareLink = `${RuntimeConfig.public.ROOT_URL}/?ft=${user?.user?.userGame?.publicId}`
  }
}
</script>

<style>
.page-leave-active {
  transition: all 0.5s;
}
.page-enter-active {
  transition: all 0.5s;
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all 0.1s ease-in-out;
}
.slide-fade-leave-active {
  transition: all 0.1s ease-in-out;
}
.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
}
</style>
